define('plugin/social-gallery/controller/SocialGalleryController',['require','lib/controller/BaseController','plugin/social-gallery/view/SocialGalleryIndexView'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var SocialGalleryIndexView = require('plugin/social-gallery/view/SocialGalleryIndexView');

    /**
     * Gallery Controller
     *
     * @class SocialGalleryController
     */
    return BaseController.extend({

        _collection: null,

        initialize: function () {
            this._collection = this.getOption('socialGalleryCollection');
            BaseController.prototype.initialize.call(this);
        },

        /**
         * index action, displays list of images
         */
        index: function() {
            var indexView = new SocialGalleryIndexView({
                collection: this._collection
            });

            this._collection.load();

            this.getMainLayout().getContentRegion().show(indexView);
        }

    });

});
